import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch } from "react-redux";
import { getForm } from "../../actions/forms";
import Joi from "joi";
import axiosInstance from "../../utils/config";
import { ClipLoader } from "react-spinners";
import PswdShown from "@material-ui/icons/Visibility";
import PswdHidden from "@material-ui/icons/VisibilityOff";
import jwt from "jsonwebtoken";
import { useHistory } from "react-router-dom";

function Login() {
  const dispatch = useDispatch(),
    [isPasswordShown, setIsPasswordShown] = useState(false),
    changePswdVisibility = (action) => {
      action === "hide" ? setIsPasswordShown(false) : setIsPasswordShown(true);
    };
  useEffect(() => {
    document.title = "Login | Ski Design";
  }, []);

  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState({ status: null, message: null });
  const [userInfo, setUserInfo] = useState({ Email: "", Password: "" });
  const [formErrors, setFormErrors] = useState({
    emailError: "",
    passwordError: "",
  });

  const schemaMap = {
    Password: Joi.string().required().max(25).min(6).label("Password field"),
    Email: Joi.string()
      .max(100)
      .min(3)
      .required()
      .email({ tlds: { allow: false } })
      .label("Email field"),
  };

  const schema = Joi.object(schemaMap);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);

    const options = { abortEarly: false };
    const { error } = schema.validate(userInfo, options);

    if (error) {
      const errors = {};
      for (let item of error.details) {
        errors[item.path[0]] = item.message;
      }
      setFormErrors({
        emailError: errors.Email,
        passwordError: errors.Password,
      });
      setSubmitting(false);
    } else {
      setSuccessMsg({ status: null, message: null });
      setFormErrors({ emailError: "", passwordError: "" });
      axiosInstance
        .post("/login", userInfo)
        .then((data) => {
          localStorage.setItem("skiUserToken", data.data.token.split(" ")[1]);
          if (data.data.data?.AccountType === "client") {
            window.location = "/client-home";
          } else if (data.data.data?.AccountType === "creative") {
            window.location = "/creative-home";
          } else if (data.data.data?.AccountType === "admin") {
            window.location = "/admin-dashboard";
          }
          setSuccessMsg({ status: true, message: data.data.message });
          setSubmitting(false);
          setFormErrors({ emailError: "", passwordError: "" });
        })
        .catch((err) => {
          setSuccessMsg({
            status: false,
            message: "Email or password is invalid, try again",
          });
          console.log(err.status);
          setSubmitting(false);
        });
    }
  };

  return (
    <>
      <div className="form-container">
        <div className="upper-rotated-container"></div>
        <div
          style={{ top: "55%" }}
          className="login-form-cont form-cont position-relative"
        >
          <h2 className="form-header">Log In</h2>
          <p className="under-header">Log In to access Ski Service</p>
          {successMsg.message && successMsg.status ? (
            <div className="alert alert-success text-center" role="alert">
              {successMsg.message}
            </div>
          ) : (
            ""
          )}
          {successMsg.message && !successMsg.status ? (
            <div className="alert alert-danger text-center" role="alert">
              {successMsg.message}
            </div>
          ) : (
            ""
          )}
          {formErrors.emailError ? (
            <p className="my-3 error">{formErrors.emailError}</p>
          ) : formErrors.passwordError ? (
            <p className="my-3 error">{formErrors.passwordError}</p>
          ) : (
            ""
          )}
          <form
            autoComplete="off"
            method="POST"
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <input
              type="email"
              required={true}
              value={userInfo.email}
              placeholder="Email Address"
              className="email"
              name="email"
              onChange={(e) =>
                setUserInfo({ ...userInfo, Email: e.target.value })
              }
            />
            <div style={{ position: "relative" }}>
              <input
                type={isPasswordShown ? "text" : "password"}
                value={userInfo.password}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, Password: e.target.value })
                }
                name="password"
                required={true}
                placeholder="Password"
                className="password my-2"
              />
              {isPasswordShown ? (
                <PswdShown
                  titleAccess="Hide password"
                  className="pswdShowHide"
                  onClick={() => changePswdVisibility("hide")}
                />
              ) : (
                <PswdHidden
                  titleAccess="Show password"
                  className="pswdShowHide"
                  onClick={() => changePswdVisibility("show")}
                />
              )}
            </div>
            <button className="login-submit-btn mt-2" onClick={handleSubmit}>
              {submitting ? <ClipLoader color="#fff" size={30} /> : "Log In"}
            </button>
            <span
              className="forgot-password my-4 link-text"
              onClick={() => dispatch(getForm("forgot_password"))}
            >
              Forgot Password
            </span>
            <p className="text-center" style={{ color: "#32403B" }}>
              Don't you an account?{" "}
              <span
                className="link-text"
                onClick={() => dispatch(getForm("register"))}
              >
                Sign Up
              </span>
            </p>
          </form>
        </div>
        <div className="lower-rotated-container"></div>
      </div>
    </>
  );
}

export default Login;
